import { Component, ElementRef, Inject, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NgxTippyProps } from 'ngx-tippy-wrapper';
import { Subscription, Subject, switchMap, of, tap, takeUntil } from 'rxjs';
import { CotizadorCreditoService } from 'src/app/services/cotizador-credito.service';
import { DataService } from 'src/app/services/data.service';
import { SecurityService } from 'src/app/services/security.service';
import { StrappiService } from 'src/app/services/strappi.service';
import { SummaryService } from 'src/app/services/summary.service';
import { TypeProduct } from 'src/app/utils/utils';
import { WINDOW } from 'src/app/utils/window';

@Component({
  selector: 'app-deadline-table-credit',
  templateUrl: './deadline-table-credit.component.html',
  styleUrls: ['./deadline-table-credit.component.scss']
})
export class DeadlineTableCreditComponent implements OnInit, OnDestroy {

  @Input() isAfin: boolean = false;
  @ViewChild('containerDeadline') private containerDeadline:
    | ElementRef
    | undefined;
  @ViewChild('table') private table: ElementRef | undefined;
  deadlines: Array<any> = [];
  subscriptionDeadlines!: Subscription;
  idQuoter: any;
  selectPeriod: string = 'period36';
  selectConcept: any;
  loadingDeadline: boolean = true;
  showDeadline: boolean = true;
  subscriptionInteractionPanel!: Subscription;

  showLeasing = false;
  showRenting = false;

  screenSize = this.window.innerWidth;
  subscriptionScreen!: Subscription;
  subscriptionInteraction!: Subscription;
  isAvanced = false;
  resetInsurance: boolean = false;

  planes: any;
  destroy: Subject<boolean> = new Subject<boolean>();

  deadlineSelect: any;
  clickEventsubscription!: Subscription;

  tippyProps: NgxTippyProps = {
    trigger: 'click',
    allowHTML: true,
    animation: 'scale-extreme',
    theme: 'bitcar' 
  };

  public typeProduct = TypeProduct
  private destroy$ = new Subject<void>();
  public resDeadlines: any;
  public creditTooltip:string = "Crédito es la opción para comprar el auto de tus sueños siendo dueño y propietario del vehículo. Define tu enganche y pagos mensuales que incluyen GPS, seguro del auto, seguro personal y auto sustituto";

  constructor(
    private cotizadorCreditService: CotizadorCreditoService,
    private dataService: DataService,
    private securityService: SecurityService,
    private strappiService: StrappiService,
    private route: ActivatedRoute,
    public summaryService: SummaryService,
    @Inject(WINDOW) private window: Window
  ) {
    this.strappiService.getPlanPage().subscribe((res: any) => {
      this.planes = {
        Credito: {
          tooltip: res.plan[3]?.tooltip ?? '',
          video: res.plan[3]?.video ?? '',
        },
      };
    });

    this.clickEventsubscription = this.dataService.getSharedFunction().subscribe((data) => {
      this.resultOfRequestNotSuccess(data);
    });
  }

  ngOnInit(): void {
    this.subscriptionScreen = this.dataService
      .getScreenSize()
      .subscribe((resp) => (this.screenSize = resp));
    this.getUrlParams();


    this.dataService.getDeadlineSelect().subscribe({
      next: (deadline: object) => {
        console.log('deadline-table-credit: Recibido deadline select:', deadline);
        this.deadlineSelect = deadline;
        if (deadline === undefined) {
          console.log('deadline-table-credit: deadline es undefined, ocultando tabla');
          this.showDeadline = false;
          this.loadingDeadline = true;
          this.resetInsurance = true;
        } else {
          console.log('deadline-table-credit: deadline válido, mostrando tabla');
          this.resetInsurance = false;
          this.showDeadline = true;
        }
      },
      error(err) {
        console.error('deadline-table-credit: Error en getDeadlineSelect:', err);
      }
    });

  }

  async getUrlParams() {
    this.route.queryParams.subscribe((params) => {
      const paramsQuote = params['quote']
        ? this.securityService.decryptData(params['quote'])
        : null;
      if (paramsQuote?.deadlineConcept && paramsQuote?.dealinePeriod) {
        this.selectConcept = paramsQuote.deadlineConcept;
        this.selectPeriod = `period${paramsQuote.dealinePeriod}`;
        this.dataService.setPeriod(paramsQuote.dealinePeriod);
      }

      this.subscriptionDeadlines = this.dataService
        .getQuoterData()
        .subscribe((resDeadlines) => {
          if (resDeadlines) {
            this.showDeadline = true;
            this.resDeadlines = resDeadlines;
            this.showDeadline = this.resetInsurance ? false : true;
            this.getDeadlines(resDeadlines);
          } else {
            this.resDeadlines = null;
            this.showDeadline = false;
            this.loadingDeadline = false;
          }
        });
    });
  }

  /* async _getUrlParams() {
    this.route.queryParams.pipe(
      tap(() => this.loadingDeadline = true),
      switchMap((params) => {
        const paramsQuote = params['quote']
          ? this.securityService.decryptData(params['quote'])
          : null;
        if (
          paramsQuote &&
          paramsQuote.deadlineConcept &&
          paramsQuote.dealinePeriod
        ) {
          this.selectConcept = paramsQuote.deadlineConcept;
          this.selectPeriod = `period${paramsQuote.dealinePeriod}`;
          this.dataService.setPeriod(paramsQuote.dealinePeriod);
        }

        return this.dataService.getQuoterData();
      }),
      switchMap((resDeadlines) => {
        this.dataService.setDeadlineCreditSelect(null);
          if (resDeadlines) {
            this.showDeadline = true;
            this.resDeadlines = resDeadlines;
            return this.getDeadlines$(resDeadlines);
          } else {
            this.resDeadlines = null;
            this.showDeadline = false;
            this.loadingDeadline = false;
            return of(null);
          }
      }),
      takeUntil(this.destroy$)
    ).subscribe({
      next: (res) => {
        if (res !== null) {
          this.typeConceptDeadLines(res);
          this.loadingDeadline = false;
          this.dataService.setInteractionUserPanel(false);
        }
      },
      error: () => {
        this.loadingDeadline = false;
        this.dataService.setInteractionUserPanel(false);
      },
    });
  } */

  // DEPRECATED: OLD Version 
  getDeadlines(request: any) {
    this.deadlines = [];
    this.loadingDeadline = true;
    
    // Verificamos que tengamos los datos mínimos necesarios
    if (!request || !request.carId) {
      console.error('getDeadlines: Request inválido o falta carId', request);
      this.loadingDeadline = false;
      this.dataService.setInteractionUserPanel(false);
      return;
    }

    this.cotizadorCreditService.generateCreditQuoter(request).subscribe({
      next: (res) => {
        console.log('generateCreditQuoter exitoso:', res);
        this.typeConceptDeadLines(res);
        this.loadingDeadline = false;
        this.dataService.setInteractionUserPanel(false);
      },
      error: (err) => {
        console.error('Error en generateCreditQuoter:', err);
        this.loadingDeadline = false;
        this.dataService.setInteractionUserPanel(false);
        
        // Intentamos mostrar un mensaje de error al usuario
        this.showDeadline = false;
        this.loadingDeadline = false;
      },
    });
  }

  /* getDeadlines$(request: any) {
    this.deadlines = [];
    return this.cotizadorCreditService.generateCreditQuoter(request);
  } */


  typeConceptDeadLines(res: any) {
    console.log('deadline-table-credit: typeConceptDeadLines ejecutándose con respuesta:', res);
    
    this.idQuoter = res.id;
    const key = res.quoterType;
    
    console.log('deadline-table-credit: Procesando quoterType:', key, 'selectPeriod:', this.selectPeriod);
    
    this.selectDeadline(
      res[key].concept,
      res[key][this.selectPeriod],
      false
    );
    const deadlineArray = this.transformArray(res[key]);
    this.deadlines = [
      { title: key, data: deadlineArray, hide: false }
    ];
    this.dataService.setTenPercentPrice(res.tenPercentPrice);
    
    console.log('deadline-table-credit: Deadlines procesados:', this.deadlines);
  }

  transformArray(data: any) {
    const newArray = [];
    for (const [key, value] of Object.entries(data)) {
      if (key !== 'concept' && key !== 'hideRenting') {
        const object = {
          type: key.replace(/\D/g, ''),
          values: value,
        };
        newArray.push(object);
      }
    }
    return newArray;
  }

  async selectDeadline(concept: string, period: any, isSelected: boolean) {
    console.log('deadline-table-credit: selectDeadline ejecutándose:', { concept, period, isSelected });
    
    if (concept === 'traditional' || concept === 'ballon') {
      this.dataService.setPeriod(period.period);
      this.selectConcept = concept;
      this.selectPeriod = `period${period.period}`;
      
      const deadlineData = {
        idQuoter: this.idQuoter,
        concept,
        ...period,
        isSelected,
      };
      
      console.log('deadline-table-credit: Estableciendo deadline credit select:', deadlineData);
      this.dataService.setDeadlineCreditSelect(deadlineData);
      this.dataService.setBalloonMax(period.period);
    }
  }

  checkSelectCard(concept: string, type: any) {
    let valuePeriod = `period${type}`;

    if(this.selectConcept === 'rr') {
      return this.selectPeriod === valuePeriod;
    } else {
      return this.selectConcept === concept && this.selectPeriod === valuePeriod;
    }    
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
    this.resetOnDestroy();
  }

  resetOnDestroy() {
    this.deadlines = [];
    this.subscriptionDeadlines.unsubscribe();
    this.subscriptionScreen.unsubscribe();
    this.clickEventsubscription.unsubscribe();
  }

  avanzar() {
    this.isAvanced = true;
    this.table!.nativeElement.scrollTo({
      left: this.table!.nativeElement.scrollLeft + 750,
      behavior: 'smooth',
    });
  }

  retroceder() {
    this.isAvanced = false;
    this.table!.nativeElement.scrollTo({
      left: this.table!.nativeElement.scrollLeft - 750,
      behavior: 'smooth',
    });
  }

  isDisableBtn() {
    return this.isAvanced ? '' : 'disabled-btn';
  }
  isDisableBtn2() {
    return this.isAvanced ? 'disabled-btn' : '';
  }

  resultOfRequestNotSuccess(data?: boolean) {
    return data;
  }

  preauthorize() {
    this.dataService.sendSharedFunction('preauthorize');
  }
}
